/* OBUOLYS — „Nutrink ir sužinok“: exit intent + scratch card + saliutai. Konfigūracija iš #ob-nt data-* atributų.
   Eiga (v2): kortelė trinama iš karto, po folija „Jūs laimėjote!“ → nutrynus ≥ 50 % — saliutai + el. pašto forma „Siųsti prizą“ →
   Worker /nutrink grąžina prizą ir kodą → rodomi pop-upe (ir laiške per Omnisend įvykį). */
(function () {
  var root = document.getElementById('ob-nt');
  if (!root || window.ObNutrink) return;
  window.ObNutrink = true;
  var url = root.getAttribute('data-url');
  var preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main'); // DEV/peržiūros tema → demo, kai Worker 503/404
  var LS = 'ob_nutrink';            // {rodyta: ts, email, prizas, kodas, iki, ...}
  var DIENOS = 14;
  var force = /[?&]nutrink=1/.test(location.search);
  var state = lsGet() || {};
  if (force) { state = {}; try { localStorage.removeItem(LS); } catch (e) {} } // ?nutrink=1 — visada nuo pradžios (peržiūrai)
  var shown = false, unlocked = false, email = null;

  function lsGet() { try { return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; } }
  function lsSet(v) { try { localStorage.setItem(LS, JSON.stringify(v)); } catch (e) {} }
  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function fmtDate(iso) { var d = new Date(iso); var M = ['sausio','vasario','kovo','balandžio','gegužės','birželio','liepos','rugpjūčio','rugsėjo','spalio','lapkričio','gruodžio']; return M[d.getMonth()] + ' ' + d.getDate() + ' d. ' + String(d.getHours()).padStart(2,'0') + ':' + String(d.getMinutes()).padStart(2,'0'); }

  var head = q('[data-nt-head]'), scratchBox = q('[data-nt-scratch]'), form = q('[data-nt-form]'), hint = q('[data-nt-hint]'),
      result = q('[data-nt-result]'), err = q('.ob-nt__err'), canvas = q('.ob-nt__canvas');

  /* ---- Omnisend pop-upai (POP Žanrai kompiuteriui / telefonui): nerodome savo ant jų, o parodę savo — užmigdome jų 7 paroms
     per tą patį slapuką, kurį Omnisend rašo paspaudus „uždaryti“ (omnisend-form-<id>-closed-at). ---- */
  var OMNI_FORMOS = ['6aa8545958b325e11198bd41', '6aa8e3ed58b325e11198c11b'];
  function omniMatoma() {
    return qa('[id^="omnisend-form-"]', document).some(function (el) {
      if (el.closest('[id^="omnisend-embedded"]')) return false;
      var cs = getComputedStyle(el); if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return false;
      var r = el.getBoundingClientRect(); return r.width > 50 && r.height > 50;
    });
  }
  function omniUzmigdyti() {
    var iso = new Date().toISOString();
    // Omnisend rašo: domain=obuolys.lt (be taško), path=/, SameSite=Lax, ~1 m. Kartojame tiksliai, kad perrašytume tą patį slapuką, o ne sukurtume antrą.
    var dom = location.hostname.replace(/^www\./, '');
    OMNI_FORMOS.forEach(function (id) { try {
      document.cookie = 'omnisend-form-' + id + '-closed-at=; path=/; max-age=0';                       // host-only kopija (jei liko iš senesnės versijos)
      document.cookie = 'omnisend-form-' + id + '-closed-at=' + iso + '; path=/; domain=' + dom + '; max-age=31536000; SameSite=Lax';
    } catch (e) {} });
  }
  function open() {
    if (shown) return;
    if (omniMatoma()) return;                     // Omnisend forma jau ekrane — nesidengiame; kitas exit intent pabandys vėl
    shown = true; omniUzmigdyti();
    root.hidden = false; document.documentElement.classList.add('ob-nt-open');
    if (state.kodas && state.iki && Date.parse(state.iki) > Date.now()) { fill(state); showResult(false); }
    else { initScratch(); }
    state.rodyta = Date.now(); lsSet(state);
  }
  function close() { root.hidden = true; document.documentElement.classList.remove('ob-nt-open'); }
  qa('[data-nt-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  function fill(s) {
    qa('[data-nt-pavadinimas]').forEach(function (el) { el.textContent = s.pavadinimas || ''; });
    var a = q('[data-nt-aprasas]'); if (a) a.textContent = s.aprasas || '';
    var k = q('[data-nt-kodas]'); if (k) k.textContent = s.kodas || '';
    var i = q('[data-nt-iki]'); if (i) i.textContent = s.iki ? fmtDate(s.iki) : '';
    var n = q('[data-nt-nuoroda]'); if (n && s.nuoroda) n.href = s.nuoroda;
    gifts(s);
  }
  function showResult(withConfetti) {
    head.hidden = true; scratchBox.hidden = true; form.hidden = true; hint.hidden = true; result.hidden = false;
    if (withConfetti) confetti();
  }
  // Dovanos prizas: pirkėjas pažymi VIENĄ knygą iš prizų lentynos (kolekcija nutrink-prizai); mygtukas įdeda ją į krepšelį
  // ir nukreipia per /discount/<kodas> — kodas pritaikomas pats, rodyti jo nereikia.
  function gifts(s) {
    var box = q('[data-nt-gifts]'), code = q('.ob-nt__code'), fine = q('[data-nt-fine]'), btn = q('[data-nt-nuoroda]');
    if (!box) return;
    if (!s.kolekcija) { box.hidden = true; if (code) code.hidden = false; return; }
    if (code) code.hidden = true;
    if (fine) fine.textContent = 'Dovana nemokama perkant bet kurią kitą prekę. Galioja iki ' + (s.iki ? fmtDate(s.iki) : '') + '. Kodas pritaikomas automatiškai.';
    btn.textContent = 'Pirma pažymėkite knygą'; btn.classList.add('is-off'); btn.href = s.nuoroda;
    fetch('/collections/' + s.kolekcija + '/products.json?limit=12').then(function (r) { return r.json(); }).then(function (j) {
      var P = (j && j.products) || []; if (!P.length) { box.hidden = true; if (code) code.hidden = false; return; }
      box.innerHTML = P.map(function (p, i) {
        var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') : '';
        var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        return '<label class="ob-nt__gift"><input type="radio" name="ob-nt-gift" value="' + vid + '" data-handle="' + p.handle + '"><span class="ob-nt__gift-img"><img src="' + img + '" alt="" loading="lazy"></span><span class="ob-nt__gift-t">' + p.title.split(':')[0].slice(0, 40) + '</span></label>';
      }).join('');
      box.hidden = false; var h = q('[data-nt-gifts-h]'); if (h) h.hidden = false;
      var chosen = null;
      box.addEventListener('change', function (e) {
        chosen = e.target; btn.textContent = 'Įdėti dovaną į krepšelį →'; btn.classList.remove('is-off');
      });
      btn.addEventListener('click', function (e) {
        if (!chosen) { e.preventDefault(); box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); return; }
        e.preventDefault(); btn.textContent = 'Dedame…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(chosen.value), quantity: 1, properties: { _nutrink: 'dovana', _nutrink_kodas: s.kodas } }] }) })
          .catch(function () {})
          .then(function () { location.href = '/discount/' + encodeURIComponent(s.kodas) + '?redirect=' + encodeURIComponent('/cart'); });
      });
    }).catch(function () { box.hidden = true; if (code) code.hidden = false; });
  }
  /* ---- el. pašto patikra (ta pati logika Worker'yje, čia — greitas atsakas) ---- */
  var LAIKINI = ['mailinator.com','guerrillamail.com','10minutemail.com','tempmail.com','temp-mail.org','yopmail.com','trashmail.com','sharklasers.com','getnada.com','dispostable.com','maildrop.cc','throwawayemail.com','fakeinbox.com','mohmal.com','1secmail.com','emailfake.com','mail.tm','dropmail.me','tempmailo.com','mailsac.com'];
  var KLAIDOS = { 'gmail.con':'gmail.com','gmail.co':'gmail.com','gmail.cm':'gmail.com','gmai.com':'gmail.com','gmial.com':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com','gmail.lt':'gmail.com','gmail.comm':'gmail.com','hotmail.con':'hotmail.com','hotmial.com':'hotmail.com','yahoo.con':'yahoo.com','outlook.con':'outlook.com','icloud.con':'icloud.com','inbox.ltt':'inbox.lt' };
  function tikrinti(v) {
    if (!v) return 'Įrašykite el. pašto adresą.';
    var m = v.match(/^([^\s@]+)@([^\s@]+)$/);
    if (!m) return 'Adresas turi būti tokio pavidalo: vardas@pastas.lt';
    var vietinis = m[1], domenas = m[2], dalys = domenas.split('.');
    if (KLAIDOS[domenas]) return 'Gal turėjote omeny ' + vietinis + '@' + KLAIDOS[domenas] + '? Pataisykite.';
    if (LAIKINI.indexOf(domenas) > -1) return 'Laikinų pašto dėžučių nepriimame — prizą siunčiame tik į tikrą paštą.';
    if (dalys.length < 2 || dalys[dalys.length - 1].length < 2 || /\d/.test(dalys[dalys.length - 1]) || /^\.|\.$|\.\./.test(vietinis) || /^-|-$|\.\.|^\.|\.$/.test(domenas)) return 'Patikrinkite el. pašto adresą — jame yra klaida.';
    if (/^(test|testas|asd|asdf|qwe|qwerty|abc|xyz|aaa|fake|none|null|nobody|noemail|no|ne|nera|nenoriu|niekas|spam|email|mail|pastas|user|admin|info|a|b|x|xx|xxx|zzz|123|1234|12345|111|000)\d*$/.test(vietinis) || /^(.)\1{2,}$/.test(vietinis) || /^[0-9]+$/.test(vietinis)) return 'Panašu į netikrą adresą. Prizas keliauja el. paštu — įrašykite tikrą.';
    if (/^(asd|asdf|qwe|qwerty|test|fake|abc|aaa|zzz|xxx)\d*\.[a-z]+$/.test(domenas) || /^(.)\1{2,}\./.test(domenas) || domenas === 'example.com' || /\.(local|test|invalid|example)$/.test(domenas)) return 'Panašu į netikrą adresą. Prizas keliauja el. paštu — įrašykite tikrą.';
    return null;
  }
  function klaidosTekstas(kodas, v) {
    if (!kodas) return 'Nepavyko. Pabandykite dar kartą.';
    if (kodas === 'limit') return 'Per daug bandymų. Pabandykite rytoj.';
    if (kodas.indexOf('klaida:') === 0) return 'Gal turėjote omeny ' + v.split('@')[0] + '@' + kodas.slice(7) + '? Pataisykite.';
    if (kodas === 'laikinas') return 'Laikinų pašto dėžučių nepriimame — prizą siunčiame tik į tikrą paštą.';
    if (kodas === 'netikras') return 'Panašu į netikrą adresą. Prizas keliauja el. paštu — įrašykite tikrą.';
    if (kodas === 'domenas') return 'Tokio pašto domeno nerandame. Patikrinkite rašybą po @.';
    if (kodas === 'email') return 'Patikrinkite el. pašto adresą — jame yra klaida.';
    return 'Nepavyko. Pabandykite dar kartą.';
  }
  /* ---- el. paštas (po nutrynimo) ---- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = q('.ob-nt__email').value.trim().toLowerCase();
    var klaida = tikrinti(v);
    if (klaida) { err.textContent = klaida; err.hidden = false; q('.ob-nt__email').focus(); return; }
    err.hidden = true;
    var btn = q('.ob-nt__btn', form); btn.disabled = true; btn.textContent = 'Siunčiame…';
    fetch(url + '/nutrink', { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: v, hp: q('.ob-nt__hp').value }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; }); })
      .catch(function () { return { _status: 0 }; })
      .then(function (j) {
        btn.disabled = false; btn.textContent = 'Siųsti prizą';
        if (!j.ok && preview && (j._status === 503 || j._status === 404 || j._status === 0)) j = /dovana/.test(location.search) ? { ok: true, prizas: 'dovana', pavadinimas: 'Dovana iš prizų lentynos', aprasas: 'Peržiūra. Išsirinkite vieną dovaną ir įdėkite į krepšelį kartu su bet kuria kita preke — dovana bus nemokama.', kodas: 'NUTRINK-DEMO42', galioja_iki: new Date(Date.now() + 48 * 36e5).toISOString(), nuoroda: '/collections/nutrink-prizai', kolekcija: 'nutrink-prizai' } : { ok: true, prizas: 'pristatymas', pavadinimas: 'Nemokamas pristatymas bet kokiam užsakymui', aprasas: 'Peržiūra. Net vienai knygai — be minimalios sumos.', kodas: 'NUTRINK-DEMO42', galioja_iki: new Date(Date.now() + 48 * 36e5).toISOString(), nuoroda: '/collections/visos-knygos' };
        if (!j.ok) { err.textContent = klaidosTekstas(j.error, v); err.hidden = false; return; }
        email = v;
        state = { rodyta: state.rodyta, email: v, prizas: j.prizas, pavadinimas: j.pavadinimas, aprasas: j.aprasas, kodas: j.kodas, iki: j.galioja_iki, nuoroda: j.nuoroda, kolekcija: j.kolekcija || null };
        lsSet(state); fill(state);
        showResult(false);
      });
  });
  var copy = q('[data-nt-copy]');
  if (copy) copy.addEventListener('click', function () {
    var t = q('[data-nt-kodas]').textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { copy.textContent = 'Nukopijuota'; setTimeout(function () { copy.textContent = 'Kopijuoti'; }, 1800); }, function () {});
  });

  /* ---- nutrinama kortelė ---- */
  var scratchInit = false;
  function initScratch() {
    if (scratchInit) return; scratchInit = true;
    var c = canvas, ctx = c.getContext('2d');
    var W = c.width, H = c.height, done = false, drawing = false, last = null;
    var g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, '#c9b26a'); g.addColorStop(.5, '#e8d8a0'); g.addColorStop(1, '#b89a4e');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = 'rgba(0,0,0,.08)'; for (var i = 0; i < 70; i++) { ctx.fillRect(Math.random() * W, Math.random() * H, 2, 2); }
    ctx.fillStyle = '#5b4a1c'; ctx.textAlign = 'center';
    ctx.font = '800 26px Archivo, Helvetica, Arial, sans-serif'; ctx.fillText('NUTRINK ČIA', W / 2, H / 2 - 6);
    ctx.font = '500 14px Archivo, Helvetica, Arial, sans-serif'; ctx.fillText('momentinė loterija', W / 2, H / 2 + 20);
    ctx.globalCompositeOperation = 'destination-out';
    function pos(e) { var r = c.getBoundingClientRect(); var t = e.touches ? e.touches[0] : e; return { x: (t.clientX - r.left) * W / r.width, y: (t.clientY - r.top) * H / r.height }; }
    function scratch(p) {
      ctx.lineWidth = 44; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.beginPath(); if (last) ctx.moveTo(last.x, last.y); else ctx.moveTo(p.x, p.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, Math.PI * 2); ctx.fill();
      last = p;
    }
    function check() {
      if (done) return;
      var d = ctx.getImageData(0, 0, W, H).data, n = 0, tot = 0;
      for (var i = 3; i < d.length; i += 4 * 16) { tot++; if (d[i] === 0) n++; }
      if (n / tot > 0.5) { done = true; c.classList.add('is-done'); confetti(); hint.hidden = true; setTimeout(function () { form.hidden = false; var e = q('.ob-nt__email'); if (e && window.innerWidth > 600) e.focus(); }, 900); }
    }
    function start(e) { e.preventDefault(); if (done) return; drawing = true; last = null; scratch(pos(e)); }
    function move(e) { if (!drawing) return; e.preventDefault(); scratch(pos(e)); }
    function end() { if (!drawing) return; drawing = false; last = null; check(); }
    c.addEventListener('mousedown', start); c.addEventListener('mousemove', move); window.addEventListener('mouseup', end);
    c.addEventListener('touchstart', start, { passive: false }); c.addEventListener('touchmove', move, { passive: false }); c.addEventListener('touchend', end);
  }

  /* ---- saliutai ---- */
  function confetti() {
    var c = q('.ob-nt__confetti'); if (!c) return;
    var ctx = c.getContext('2d'), W = c.width, H = c.height, P = [], colors = ['#16a34a', '#D6287A', '#f59e0b', '#1d1d1d', '#60a5fa', '#e8d8a0'];
    for (var i = 0; i < 140; i++) P.push({ x: W / 2 + (Math.random() - .5) * 120, y: H * .45, vx: (Math.random() - .5) * 14, vy: -Math.random() * 14 - 4, r: 4 + Math.random() * 5, a: Math.random() * Math.PI, va: (Math.random() - .5) * .3, col: colors[i % colors.length], life: 90 + Math.random() * 40 });
    var t = 0;
    (function frame() {
      ctx.clearRect(0, 0, W, H); t++;
      var alive = false;
      P.forEach(function (p) { if (p.life <= 0) return; alive = true; p.life--; p.vy += .35; p.vx *= .99; p.x += p.vx; p.y += p.vy; p.a += p.va;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = Math.min(1, p.life / 30); ctx.fillStyle = p.col; ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * .6); ctx.restore(); });
      if (alive && t < 200) requestAnimationFrame(frame); else ctx.clearRect(0, 0, W, H);
    })();
  }

  /* ---- exit intent ---- */
  var recent = state.rodyta && (Date.now() - state.rodyta) < DIENOS * 864e5;
  var hasValidCode = state.kodas && state.iki && Date.parse(state.iki) > Date.now();
  if (force) { open(); return; }
  if (recent || hasValidCode) return;           // rodyta per 14 d. arba kodą jau turi — nebevarginame
  var t0 = Date.now(), MIN_MS = 12000;
  document.addEventListener('mouseout', function (e) {
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 8) return;
    if (Date.now() - t0 < MIN_MS) return;
    open();
  });
  if (window.innerWidth <= 820) {
    var maxY = 0, lastY = window.scrollY, lastT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY, now = Date.now(), dh = document.documentElement.scrollHeight - window.innerHeight;
      if (y > maxY) maxY = y;
      var v = (lastY - y) / Math.max(1, now - lastT);
      if (dh > 0 && maxY / dh > 0.4 && v > 1.2 && Date.now() - t0 > MIN_MS) open();
      lastY = y; lastT = now;
    }, { passive: true });
    // 45 s laikmatis išimtas (Paulius 2026-10-11): rodome TIK exit intent — telefone tai greitas slinkimas atgal į viršų.
  }
})();

/* v3 153424 */
